import api from '@/helpers/api'

const API_PRIVACY_POLICY = `/api/policies/`
const API_TERMS_CONDITIONS = `/api/terms-conditions/`
const API_PUBLIC_PRIVACY_POLICY = `/api/public/privacy-policy`
const API_PUBLIC_TERMS_CONDITIONS = `/api/public/terms-conditions`

export default {
  namespaced: true,
  state: {
    status: '',
    privacyPolicy: '',
    termsConditions: '',
    public_privacy_policy: null,
    public_terms_conditions: null,
    errMessage: ''
  },
  mutations: {
    request(state) {
      state.status = 'loading'
    },
    success(state) {
      state.status = 'success'
    },
    error(state, { message }) {
      state.status = 'error'
      state.errMessage = message
    },

    set_privacy_policy(state, { content }) {
      state.privacyPolicy = content
    },
    set_terms_conditions(state, { content }) {
      state.termsConditions = content
    },

    set_public_privacy_policy(state, { content }) {
      state.public_privacy_policy = { content }
    },
    set_public_terms_conditions(state, { content }) {
      state.public_terms_conditions = { content }
    },

    clear_error(state) {
      state.errMessage = ''
      state.status = ''
    }
  },
  actions: {
    delete_privacy_policy({ commit }) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('delete', `${API_PRIVACY_POLICY}`)
          .then((result) => {
            commit('set_privacy_policy', { content: '' })
            commit('success')
            return resolve(result.data)
          })
          .catch((err) => {
            commit('error', { message: err })
            return reject(err)
          })
      })
    },
    delete_terms_conditions({ commit }) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('delete', `${API_TERMS_CONDITIONS}`)
          .then((result) => {
            commit('set_terms_conditions', { content: '' })
            commit('success')
            return resolve(result.data)
          })
          .catch((err) => {
            commit('error', { message: err })
            return reject(err)
          })
      })
    },

    get_privacy_policy({ commit }) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('get', `${API_PRIVACY_POLICY}`)
          .then((result) => {
            const content = result.data.data?.content || ''
            commit('set_privacy_policy', { content })
            commit('success')
            return resolve(result.data.data)
          })
          .catch((err) => {
            commit('error', { message: err })
            return reject(err)
          })
      })
    },
    get_terms_conditions({ commit }) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('get', `${API_TERMS_CONDITIONS}`)
          .then((result) => {
            const content = result.data.data?.content || ''
            commit('set_terms_conditions', { content })
            commit('success')
            return resolve(result.data.data)
          })
          .catch((err) => {
            commit('error', { message: err })
            return reject(err)
          })
      })
    },
    save_privacy_policy({ commit }, { content }) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('post', `${API_PRIVACY_POLICY}`, {}, { content })
          .then((result) => {
            commit('set_privacy_policy', { content })
            commit('success')
            return resolve(result.data)
          })
          .catch((err) => {
            commit('error', { message: err })
            return reject(err)
          })
      })
    },
    save_terms_conditions({ commit }, { content }) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('post', `${API_TERMS_CONDITIONS}`, {}, { content })
          .then((result) => {
            commit('set_terms_conditions', { content })
            commit('success')
            return resolve(result.data)
          })
          .catch((err) => {
            commit('error', { message: err })
            return reject(err)
          })
      })
    },
    update_privacy_policy({ commit }, { content }) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('put', `${API_PRIVACY_POLICY}`, {}, { content })
          .then((result) => {
            commit('set_privacy_policy', { content })
            commit('success')
            return resolve(result.data)
          })
          .catch((err) => {
            commit('error', { message: err })
            return reject(err)
          })
      })
    },
    update_terms_conditions({ commit }, { content }) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('put', `${API_TERMS_CONDITIONS}`, {}, { content })
          .then((result) => {
            commit('set_terms_conditions', { content })
            commit('success')
            return resolve(result.data)
          })
          .catch((err) => {
            commit('error', { message: err })
            return reject(err)
          })
      })
    },

    // Public methods for displaying policies - SIMPLIFIED
    get_public_privacy_policy({ commit }) {
      commit('request')

      return new Promise((resolve, reject) => {
        // Simple: just get content, no formatting needed
        api.request('get', `${API_PUBLIC_PRIVACY_POLICY}`)
          .then((result) => {
            const content = result.data.data?.content || '';
            
            commit('set_public_privacy_policy', { 
              content: content
            })
            commit('success')
            return resolve({
              content: content,
              updated_at: result.data.data?.updated_at
            });
          })
          .catch((err) => {
            commit('error', { message: err })
            return reject(err)
          })
      })
    },
    get_public_terms_conditions({ commit }) {
      commit('request')

      return new Promise((resolve, reject) => {
        // Simple: just get content, no formatting needed
        api.request('get', `${API_PUBLIC_TERMS_CONDITIONS}`)
          .then((result) => {
            const content = result.data.data?.content || '';
            
            commit('set_public_terms_conditions', { 
              content: content
            })
            commit('success')
            return resolve({
              content: content,
              updated_at: result.data.data?.updated_at
            });
          })
          .catch((err) => {
            commit('error', { message: err })
            return reject(err)
          })
      })
    },

    clear_errors({ commit }) {
      commit('clear_error')
    }
  },
  getters: {
    privacyPolicy: (state) => state.privacyPolicy,
    termsConditions: (state) => state.termsConditions,
    publicPrivacyPolicy: (state) => state.public_privacy_policy?.content || '',
    publicTermsConditions: (state) => state.public_terms_conditions?.content || '',
    isLoading: (state) => state.status === 'loading',
    hasError: (state) => state.status === 'error',
    errorMessage: (state) => state.errMessage
  }
}